import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { api, formatErr } from "@/lib/api";
import { SECTIONS, SECTION_HINTS } from "@/components/admin/labels";
import { ObjectFields } from "@/components/admin/FieldEditor";

export const AUTOSAVE_EVENT = "am:autosave";

export const ContentEditor = () => {
  const [data, setData] = useState(null);
  const [sec, setSec] = useState("hero");
  const [dirty, setDirty] = useState(false);
  const [busy, setBusy] = useState(false);
  const [autoSave, setAutoSave] = useState(false);

  useEffect(() => { api.get("/content").then(({ data: d }) => setData(d)); }, []);

  const save = useCallback(async (d, msg = "Zmiany zapisane – są już widoczne na stronie") => {
    setBusy(true);
    try { await api.put("/content", d); setDirty(false); toast.success(msg); }
    catch (e) { toast.error(formatErr(e)); } finally { setBusy(false); }
  }, []);

  useEffect(() => {
    const on = () => setAutoSave(true);
    window.addEventListener(AUTOSAVE_EVENT, on);
    return () => window.removeEventListener(AUTOSAVE_EVENT, on);
  }, []);

  useEffect(() => {
    if (!autoSave || !data) return;
    setAutoSave(false);
    save(data, "Zdjęcie zapisane – jest już widoczne na stronie");
  }, [autoSave, data, save]);
  const reset = async () => {
    if (!window.confirm("Przywrócić całą treść strony do wersji domyślnej? Tej operacji nie można cofnąć.")) return;
    try { const { data: d } = await api.post("/content/reset"); setData(d); setDirty(false); toast.success("Przywrócono treść domyślną"); }
    catch (e) { toast.error(formatErr(e)); }
  };

  if (!data) return <p className="adm-sub">Ładowanie…</p>;

  return (
    <div data-testid="admin-content-editor">
      <h1>Treść strony</h1>
      <p className="adm-sub">Wybierz sekcję, zmień teksty, ceny i zdjęcia, a potem kliknij „Zapisz zmiany”.</p>
      <div className="adm-grid" style={{ marginTop: 36 }}>
        <div className="adm-side">
          {SECTIONS.map(([k, t]) => <button key={k} className={sec === k ? "on" : ""} onClick={() => setSec(k)} data-testid={`content-section-${k}`}>{t}</button>)}
        </div>
        <div>
          <h2 style={{ fontSize: 30, marginBottom: SECTION_HINTS[sec] ? 8 : 24 }}>{SECTIONS.find((s) => s[0] === sec)[1]}</h2>
          {SECTION_HINTS[sec] && <p className="adm-sub" style={{ marginBottom: 24 }} data-testid="section-hint">{SECTION_HINTS[sec]}</p>}
          <ObjectFields key={sec} path={sec} value={data[sec]} onChange={(v) => { setData({ ...data, [sec]: v }); setDirty(true); }} />
          <div className="adm-bar">
            <span className="adm-sub" style={{ margin: 0 }} data-testid="content-dirty-state">{dirty ? "Masz niezapisane zmiany" : "Wszystko zapisane"}</span>
            <div className="fe-actions">
              <button className="btn line" onClick={reset} data-testid="content-reset-btn">Przywróć domyślne</button>
              <button className="btn solid" onClick={() => save(data)} disabled={busy || !dirty} data-testid="content-save-btn">{busy ? "Zapisywanie…" : "Zapisz zmiany"}</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
